const initialState = {
    appInit: false,
    activeStep: 0,
    loading: false,
    isAuthenticated: false,
    timeOutLogoutMessage: false,
    language: "sv",

    formValues: {
        step1: {},
        unemploymentForm: {},
        workIncapacityForm: {},
        hospitalisedForm: {},
    },
    selectedClaim: 0,
    customer: {},
    insurances: [],
    claimEvents: [],
    claimDate: null,
};

const reducer = (state, action) => {

    switch (action.type) {
        case "setLanguage": {
            return {
                ...state,
                language: action.value,
            };
        }

        case "setTimeOutLogoutMessage": {
            return {
                ...state,
                timeOutLogoutMessage: action.value,
            };
        }

        case "setAppInit": {
            return {
                ...state,
                appInit: action.value,
            };
        }

        case "setIsAuthenticated": {
            return {
                ...state,
                isAuthenticated: action.value,
            };
        }

        case "setClaimDate": {
            return {
                ...state,
                claimDate: action.payload,
            };
        }

        case "setClaimEvents": {
            return {
                ...state,
                claimEvents: action.payload,
            };
        }

        case "setInsurances": {
            return {
                ...state,
                insurances: action.payload,
            };
        }

        case "setCustomer": {
            return {
                ...state,
                customer: action.payload,
            };
        }

        case "setSelectedClaim": {
            return {
                ...state,
                selectedClaim: action.payload,
            };
        }

        case "setStep1": {
            state.formValues.step1 = {
                ...state.formValues.step1,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setWorkIncapacityForm": {
            state.formValues.workIncapacityForm = {
                ...state.formValues.workIncapacityForm,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setUnemploymentForm": {
            state.formValues.unemploymentForm = {
                ...state.formValues.unemploymentForm,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setHospitalisedForm": {
            state.formValues.hospitalisedForm = {
                ...state.formValues.hospitalisedForm,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "resetForms": {
            state.formValues.step1 = {};
            state.formValues.unemploymentForm = {};
            state.formValues.workIncapacityForm = {};
            state.hospitalisedForm = {};
            return {
                ...state,
            };
        }

        case "resetProduct": {
            state.formValues.product = {};
            state.formValues.addon = {};
            state.formValues.estate = {};
            state.activeProduct = null;
            return {
                ...state,
            };
        }

        //case "setAppInit": {
        //  return {
        //    ...state,
        //    appInit: action.value,
        //  };
        //}
        case "setLoading": {
            return {
                ...state,
                loading: action.value,
            };
        }

        case "setActiveStep": {
            return {
                ...state,
                activeStep: action.payload,
            };
        }

        case "setPartners": {
            return {
                ...state,
                partners: action.payload,
            };
        }

        case "setAgreements": {
            return {
                ...state,
                agreements: action.payload,
            };
        }

        case "setAgreement": {
            return {
                ...state,
                agreement: action.payload,
            };
        }

        case "setObjectType": {
            return {
                ...state,
                objectType: action.payload,
            };
        }

        case "setBroker": {
            state.formValues.broker = {
                ...state.formValues.broker,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setPartner": {
            state.partner = {
                ...state.partner,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setApprovePartnerInfo": {
            state.approve.partnerInfo = action.payload;
            return {
                ...state,
            };
        }

        case "setEstate": {
            state.formValues.estate = {
                ...state.formValues.estate,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setProduct": {
            state.formValues.product = {
                ...state.formValues.product,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setAddonProduct": {
            state.formValues.addon = {
                ...state.formValues.addon,
                ...action.payload,
            };
            return {
                ...state,
            };
        }

        case "setSellers": {
            state.formValues.sellers = action.payload;
            return {
                ...state,
            };
        }

        case "setInvoiceRecipient": {
            state.formValues.reciever = action.payload;
            return {
                ...state,
            };
        }

        case "setProductOverview": {
            return {
                ...state,
                products: action.payload.products,
                messages: action.payload.messages,
                documents: action.payload.documents,
                objectFields: action.payload.objectFields,
                productFields: action.payload.productFields,
            };
        }

        case "setPartnerData": {
            const objectType = action.payload?.fields?.find((x) => /objecttype/.test(x.businessName));
            state.objectType = objectType ? parseInt(objectType.value) : 0;

            const assignementDate = action.payload?.fields?.find((x) => /assignmentdate/.test(x.businessName));
            state.assignmentDate = assignementDate ? assignementDate.value : null;

            state.formValues.sellers = action.payload?.sellers || [{ name: "" }];
            state.partner = {
                ...state.partner,
                ...action.payload?.contact,
            };
            state.partnerData = action.payload?.fields;

            return {
                ...state,
            };
        }

        case "setSelectedDate": {
            return {
                ...state,
                assignmentDate: action.value.toISOString().substring(0, 10),
            };
        }

        case "setActiveProduct": {
            state.activeProduct = action.payload;
            return {
                ...state,
            };
        }

        case "confirmApprove": {
            state.approve.confirmed = state.approve.gdpr;
            return { ...state };
        }

        case "editApprove": {
            state.approve[action.key.toLowerCase()] = action.value;
            return { ...state };
        }

        case "editFormValue": {
            if (action.category) {
                state.formValues[action.category][action.key.toLowerCase()] = action.value;
            } else {
                state.formValues[action.key.toLowerCase()] = action.value;
            }

            return { ...state };
        }

        case "emptyFormValue": {
            return {
                ...state,
                formValues: initialState.formValues,
                product: null,
            };
        }

        default:
            return state;
    }
};

export { initialState, reducer };
